import React, { Component, Fragment } from "react";
import { withRouter, Link } from "react-router-dom";
import { Col, Row, } from "react-bootstrap";
import ReactTable from "react-table";
import debounce from "lodash/debounce";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import SystemLogsService from "../../../services/SystemLogsService";
import HandleError from "../../../services/HandleError";
import SystemLogDetailsModal from "../../modals/SystemLogDetailsModal";

class SystemLogsPage extends Component {
	state = {
		isLoadingTable: true,
		showDetailsModal:false,
		selectedLog: {},
		data: [],
		pages: 1,
	}

	getSystemLogs= (state) => {
		const {pageSize, sorted, filtered, page } = state;
		const data = JSON.stringify({pageSize, sorted, filtered, page});
		this.setState({ isLoadingTable: true});
		this.systemLogsService.index(page+1, `data=${data}`)
			.then((res) => {
				this.setState({ isLoadingTable:false, data: res.data.data, pages: res.data.last_page, pageState: state});
			}).catch((err) => {
				this.setState({isLoadingTable:false});
				HandleError(err,this);
			});
	}

	handleSystemLogDetailsModal = (log) => {
		if(log) {
			this.setState({ showDetailsModal: true, selectedLog: log });
		}
	}

	handleClose = () => { this.setState({ showDetailsModal: false });}

    
    systemLogsService = new SystemLogsService(this);

    render() {
    	const { data, isLoadingTable, pages, showDetailsModal, selectedLog } = this.state;
    	return (
    		<div className="crud-page system-logs-page">
    			<div className="container-fluid">
    				<section className="actions">
    					<Row>
    						<Col md={6} sm={6} xs={12}>
    							<h2 className="page-title">System Logs</h2>
    						</Col>
    					</Row>   
    				</section>
    				<div className="card card-top-border connection-card fadeInLoadUp">
    					<ReactTable
    						columns={[						
    							{
    								Header: "User",
    								accessor: "user",
    								Cell: row => <div className="text-center"><button className="btn-name" onClick={() => this.handleSystemLogDetailsModal(row.original)}>{row.value}</button></div>,
    								minWidth: 150
    							},{
    								Header: "From",
    								accessor: "from",
    								Cell: row => <div className="text-center">{row.value}</div>,
    								minWidth: 200
    							}, {
    								Header: "Type",
    								accessor: "type",
    								Cell: row => <div className="text-center">{row.value}</div>,
    								minWidth: 150
    							}
    							,{
    								Header: "Description",
    								accessor: "description",
    								Cell: row => <div className="text-center">{row.value}</div>,
    								minWidth: 300
    							},{
    								Header: "Created at",
    								accessor: "created_at",
    								Cell: row => (<div className="text-center">{moment(row.value).format("DD-MM-YYYY HH:mm")}</div>),
    								minWidth: 150
    							}
    						]}
    						manual 
    						data={data}
    						pages={pages} 
    						loading={isLoadingTable}
    						onFetchData={ debounce(this.getSystemLogs, 400) } 
    						filterable
    						defaultSorted={[{ id: "created_at", desc: true }]}
    						defaultPageSize={20}
    						className="-highlight"
    					/>
    					<SystemLogDetailsModal
    						showDetailsModal={showDetailsModal} 
    						handleClose={this.handleClose}
    						selectedLog={selectedLog}						
    					/>
    				</div>   
    			</div>
    		</div>
    	);
    }
}

export default SystemLogsPage;




// WEBPACK FOOTER //
// ./src/components/pages/system-logs/SystemLogsPage.js